import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { VisitMonitor } from "@/features/office/vendors/visit-monitor";
import { VisitMonitoringGate } from "@/features/shared/feature-gates/visit-monitoring-gate";
import { maskSearchFragment } from "@/features/shared/route-masking";

// Lenient: strict enums on URL params crash the page (webapp-routing.md).
// `day` ("today", "tomorrow" or yyyy-MM-dd) and `tab` are narrowed in the page.
const searchSchema = z.object({
  day: z.string().optional().catch(undefined),
  tab: z.string().optional().catch(undefined),
  ...maskSearchFragment,
});

export const routeId = "/office/vendors/visit-monitor";
export const Route = createFileRoute("/office/vendors/visit-monitor")({
  validateSearch: searchSchema,
  component: () => (
    <VisitMonitoringGate>
      <VisitMonitor />
    </VisitMonitoringGate>
  ),
});
